export default "__VITE_ASSET__BqNSvpo5__"